import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {} from "../Features/SmsGatewaysdata";
import { RootState, AppDispatch } from "../Appstore/store";
import { setIsLoading } from "../Features/loadingSlice";
import { formatDate } from "../helper";
import { SmsCampaignListRecord } from "../Components/Viewsmscampaignlist";
import { GetSmtpCampaignReport } from "../Features/Smtpcampaignreports/Smtpcampaignreports";
import { IoMdArrowRoundBack } from "react-icons/io";
import { GetallSmtpCampaignReportDawnlaod } from "../Features/Smtpcampaignreports/Smtpcampaignreportdawnload";
import { RenderPaginationButtons } from "./Paginations";
import { MdClear } from "react-icons/md";
import { BiExport } from "react-icons/bi";
import { GetallSmtpCampaign } from "../Features/smtpcampaign/Smtpcampaign";

function Viewsmtpcampaignreports() {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const limit = 10;
  const [isExporting, setIsExporting] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const { id }: any = useParams();
  const navigate = useNavigate();

  const { smtpcampaignreportdata, loading, info, error } = useSelector(
    (state: RootState) => state.smtpcampaignreports
  );
  const recordreport: SmsCampaignListRecord | any =
    smtpcampaignreportdata || [];

  const [gatewayName, setGatewayName] = useState("");
  const [gatewayEmail, setGatewayEmail] = useState("");
  const [receiverEmail, setReceiverEmail] = useState("");
  const [status, setStatus] = useState("");
  const [retryStatus, setretryStatus] = useState("");
  const [attempt, setAttempt] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(
        GetSmtpCampaignReport({
          id: id,
          smtp_gateway_name: gatewayName,
          smtp_gatewayemail: gatewayEmail,
          receiver_email: receiverEmail,
          status: status ? parseInt(status, 10) : undefined,
          retry_status: retryStatus ? parseInt(retryStatus, 10) : undefined,
          attempt: attempt ? parseInt(attempt, 10) : undefined,
          limit: limit,
          page: currentPage,
        })
      );
    }, 0);
    return () => clearTimeout(timer);
  }, [dispatch, currentPage, limit, id]);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(
        GetSmtpCampaignReport({
          id: id,
          smtp_gateway_name: gatewayName,
          smtp_gatewayemail: gatewayEmail,
          receiver_email: receiverEmail,
          status: status ? parseInt(status, 10) : undefined,
          retry_status: retryStatus ? parseInt(retryStatus, 10) : undefined,
          attempt: attempt ? parseInt(attempt, 10) : undefined,
          limit: limit,
          page: currentPage,
        })
      );
    }, 500);
    return () => clearTimeout(timer);
  }, [
    dispatch,
    gatewayName,
    gatewayEmail,
    receiverEmail,
    status,
    retryStatus,
    attempt,
  ]);

  const handleDownload = () => {
    setIsExporting(true);
    dispatch(
      GetallSmtpCampaignReportDawnlaod({
        id: id,
        smtp_gateway_name: gatewayName,
        smtp_gatewayemail: gatewayEmail,
        receiver_email: receiverEmail,
        status: status ? parseInt(status, 10) : undefined,
        retry_status: retryStatus ? parseInt(retryStatus, 10) : undefined,
        attempt: attempt ? parseInt(attempt, 10) : undefined,
        limit: limit,
        page: currentPage,
      })
    )
      .then((response) => {
        if (
          response.meta.requestStatus === "fulfilled" &&
          response.payload instanceof Blob
        ) {
          const blob = response.payload;

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Smtp-Campaign-Report_${new Date().toISOString()}.xlsx`;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .finally(() => {
        setTimeout(() => {
          setIsExporting(false);
        }, 500);
      });
  };

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= (info?.total_page || 1)) {
      setCurrentPage(page);
    }
  };
  const handlebackbutton = () => {
    navigate(-1);
    dispatch(GetallSmtpCampaign({ search: "", page: 1, limit: 10 }));
  };
  const handleClearSearchFilter = () => {
    setGatewayName("");
    setGatewayEmail("");
    setReceiverEmail("");
    setStatus("");
    setretryStatus("");
    setAttempt("");
    setCurrentPage(1);
  };

  if (error) {
    <div>No found data</div>;
  }

  return (
    <div className="wrapper">
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card mt-4">
              <div className="rounded-top bg-white p-3 d-md-flex justify-content-sm-between">
                <div className="d-flex justify-content-between w-100">
                  <h2 className="mb-0 fs-3">SMTP Campaign Reports</h2>
                  <div className="d-flex">
                    <button
                      onClick={handleClearSearchFilter}
                      className="d-md-block d-none width-reports-header-buttons mt-md-0 mt-2 btn btn-secondary d-flex align-items-center"
                      style={{ width: 122 }}
                    >
                      <MdClear className="fs-5" />
                      Clear Filter
                    </button>
                    <button
                      onClick={handleDownload}
                      className="d-md-block d-none width-reports-header-buttons btn btn-info bg-success ms-2 text-white mt-md-0 mt-2 d-flex align-items-center fw-semibold"
                      disabled={isExporting}
                    >
                      <BiExport className="fs-5" />
                      {isExporting ? "Exporting..." : `Export `}
                    </button>
                    <div>
                      <button
                        onClick={handlebackbutton}
                        className="btn btn-info ms-md-2 mt-md-0 text-white d-flex align-items-center fw-semibold"
                      >
                        <IoMdArrowRoundBack /> Back
                      </button>
                    </div>
                  </div>
                </div>
                <div className="d-flex d-md-none flex-wrap justify-content-between">
                  <div className="w-50">
                    <button
                      onClick={handleClearSearchFilter}
                      className="w-100 mt-md-0 mt-3 btn btn-secondary d-flex align-items-center justify-content-center"
                      style={{ width: 122 }}
                    >
                      <MdClear className="fs-5" />
                      Clear Filter
                    </button>
                  </div>
                  <div className="w-50">
                    <button
                      onClick={handleDownload}
                      className="w-100 btn btn-info bg-success ms-2 text-white mt-md-0 mt-3 d-flex align-items-center fw-semibold justify-content-center"
                      disabled={isExporting}
                    >
                      <BiExport className="fs-5" />
                      {isExporting ? "Exporting..." : `Export `}
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body border-start-0 border-end-0 p-0">
                <>
                  <div className="table-responsive">
                    <table className="table table-hover table-bordered text-nowrap">
                      <thead>
                        <tr>
                          <th className="ps-3 sr-no">SR No</th>
                          <th>Smtp Gateway Name</th>
                          <th>From Email</th>
                          <th>To Email</th>
                          <th
                            className=" text-center"
                            style={{ minWidth: 151 }}
                          >
                            Status
                          </th>
                          <th className="text-center" style={{ width: 151 }}>
                            Attempt
                          </th>
                          <th
                            className="text-center createdat"
                            style={{ minWidth: 151 }}
                          >
                            Retry Status
                          </th>
                          <th
                            className="createdat text-center"
                            style={{ minWidth: 170 }}
                          >
                            Retry At
                          </th>
                          <th className="text-center" style={{ minWidth: 130 }}>
                            Retry Error Code
                          </th>
                          <th className="text-center">Retry Error Message</th>
                          <th className="text-center" style={{ minWidth: 130 }}>
                            Error Code
                          </th>
                          <th className="text-center">Error Message</th>
                          <th className="text-center createdat">CreatedAt</th>
                        </tr>
                        <tr>
                          <th className="ps-3"></th>
                          <th>
                            <input
                              type="text"
                              placeholder="Search Gateway Name"
                              onChange={(e) =>
                                setGatewayName(e.target.value.trim())
                              }
                              className="form-control"
                              value={gatewayName}
                            />
                          </th>
                          <th>
                            <input
                              type="text"
                              placeholder="Search Gateway Email"
                              onChange={(e) =>
                                setGatewayEmail(e.target.value.trim())
                              }
                              className="form-control"
                              value={gatewayEmail}
                            />
                          </th>
                          <th>
                            <input
                              type="text"
                              placeholder="Search Receiver Email"
                              onChange={(e) =>
                                setReceiverEmail(e.target.value.trim())
                              }
                              className="form-control"
                              value={receiverEmail}
                            />
                          </th>
                          <th>
                            <select
                              onChange={(e) => setStatus(e.target.value.trim())}
                              className="form-control"
                              value={status}
                            >
                              <option value="">All Status</option>
                              <option value="0">Failed</option>
                              <option value="1">Success</option>
                            </select>
                          </th>
                          <th>
                            <input
                              type="text"
                              placeholder="Search Attempt"
                              onChange={(e) =>
                                setAttempt(e.target.value.trim())
                              }
                              className="form-control"
                              value={attempt}
                            />
                          </th>
                          <th>
                            <select
                              onChange={(e) =>
                                setretryStatus(e.target.value.trim())
                              }
                              className="form-control"
                              value={retryStatus}
                            >
                              <option value="">All Retry Status</option>
                              <option value="0">Failed</option>
                              <option value="1">Success</option>
                            </select>
                          </th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>

                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={14} height={100}>
                              <div className="text-center">
                                <div className="loader"></div>
                              </div>
                            </td>
                          </tr>
                        ) : !recordreport || recordreport.length === 0 ? (
                          <tr>
                            <td colSpan={14} height={50}>
                              <div className="text-center">
                                <p className="mb-0 fs-5 fw-semibold">
                                  No data found
                                </p>
                              </div>
                            </td>
                          </tr>
                        ) : error?.length === 0 ? (
                          <tr>
                            <td colSpan={14} height={50}>
                              <div className="text-center">
                                <p className="mb-0 fs-5 fw-semibold">
                                  No data found
                                </p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          recordreport.map((item: any, index: number) => (
                            <tr key={item.id}>
                              <td className="ps-3">
                                {(currentPage - 1) * limit + index + 1}
                              </td>
                              <td>{item.smtp_gateway?.gateway_name || "-"}</td>
                              <td>{item.smtp_gateway?.from_email || "-"}</td>
                              <td>{item.receiver_email}</td>

                              <td
                                className={`text-center ${
                                  item?.status === 0
                                    ? "text-danger fw-bold"
                                    : item?.status === 1
                                    ? "text-success fw-bold"
                                    : "text-muted"
                                }`}
                              >
                                {item.status === 0
                                  ? "Failed"
                                  : item.status === 1
                                  ? "Success"
                                  : " - "}
                              </td>

                              <td className="text-center">
                                {item.attempt || "-"}
                              </td>

                              <td
                                className={`text-center ${
                                  item?.retry_status === 0
                                    ? "text-danger fw-bold"
                                    : item?.retry_status === 1
                                    ? "text-success fw-bold"
                                    : "text-muted"
                                }`}
                              >
                                {item.retry_status === 0
                                  ? "Failed"
                                  : item.retry_status === 1
                                  ? "Success"
                                  : " - "}
                              </td>

                              <td className="text-center">
                                {formatDate(item.retry_at) || "-"}
                              </td>
                              <td className="text-center">
                                {item.retry_error_code || "-"}
                              </td>
                              <td className="text-center">
                                {item.retry_error_message || "-"}
                              </td>
                              <td className="text-center">
                                {item.error_code || "-"}
                              </td>
                              <td className="text-center">
                                {item.error_message || "-"}
                              </td>
                              <td className="text-center">
                                {formatDate(item.createdAt) || "-"}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  {!recordreport || recordreport.length === 0 ? (
                    <div></div>
                  ) : (
                    <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                      <RenderPaginationButtons
                        info={info}
                        currentPage={currentPage}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  )}
                </>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Viewsmtpcampaignreports;
